/*
 * @Author: Veto [关于活动部分 路由]
 * @Date: 2021-06-16 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-02-01 16:32:24
 */

import PigSign from '../views/common/pigSign';
import SandPay from '../views/common/sandPay';
import WithdrawIOS from '../views/common/withdraw_ios';

import ShareAudioRoom from '../views/common/shareAudioRoom.vue';
import YunBaoGame from '../views/pages/sl/game.vue';
import ShareClose from '../views/common/close.vue';
import ErrorAccess from '../views/common/errorAccess.vue';


const router = {
    '/pig-sign-callback': PigSign,
    '/sandpay': SandPay,

    '/out-ios': WithdrawIOS,
    '/audio-room': ShareAudioRoom,

    '/love-yunbao': YunBaoGame,
    '/share-close': ShareClose,
    '/error-access': ErrorAccess
};


export default router;